/**
 * 答题/错题记录展示范围配置（单一来源）
 */

// 各记录页仅展示最近多少天的数据（含今天）。需要调整展示范围时，只改这一个值即可。
export const RECENT_RECORD_DAYS = 7;

// 近 RECENT_RECORD_DAYS 天的起始时刻，返回 unix 秒（用于按 create_time 过滤题目记录）
export function getRecentCutoffTsSec(days: number = RECENT_RECORD_DAYS): number {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (days - 1), 0, 0, 0, 0);
    return Math.floor(start.getTime() / 1000);
}

// 近 RECENT_RECORD_DAYS 天的起始日期字符串 YYYY-MM-DD（用于按日期文本过滤）
export function getRecentCutoffDate(days: number = RECENT_RECORD_DAYS): string {
    const now = new Date();
    const c = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (days - 1));
    const m = `${c.getMonth() + 1}`.padStart(2, '0');
    const d = `${c.getDate()}`.padStart(2, '0');
    return `${c.getFullYear()}-${m}-${d}`;
}
